import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/uiux/UIUXPageClient.jsx");
